import { Label } from "@tql/ui-components-react/kendo/labels";
import { Input } from "@tql/ui-components-react/tql/inputs/beta";

import type { PaymentMethodFormErrors } from "../../hooks/use-payment-method-form-validation.ts";
import {
	FieldErrorMessage,
	fieldErrorWrapperClass,
} from "../field-error/field-error.tsx";
import styles from "./billing-city-state-zip.module.css";

type BillingCityStateZipProps = Readonly<{
	newPaymentValues: {
		city: string;
		state: string;
		zip: string;
		country: string;
	};
	handleSetNewPaymentValue: (field: string, value: string) => void;
	errors: PaymentMethodFormErrors;
}>;

export const BillingCityStateZip = ({
	newPaymentValues,
	handleSetNewPaymentValue,
	errors,
}: BillingCityStateZipProps) => {
	return (
		<div className={styles.billingRow}>
			<div>
				<Label>
					City <span className={"required"}>&nbsp;*</span>
				</Label>
				<div className={errors.city ? fieldErrorWrapperClass : undefined}>
					<Input
						onChange={(e) =>
							handleSetNewPaymentValue("city", e.target.value as string)
						}
						value={newPaymentValues.city}
					/>
				</div>
				{errors.city ? <FieldErrorMessage /> : null}
			</div>
			<div>
				<Label>
					State <span className={"required"}>&nbsp;*</span>
				</Label>
				<div className={errors.state ? fieldErrorWrapperClass : undefined}>
					<Input
						onChange={(e) =>
							handleSetNewPaymentValue("state", e.target.value as string)
						}
						value={newPaymentValues.state}
					/>
				</div>
				{errors.state ? <FieldErrorMessage /> : null}
			</div>
			<div>
				<Label>
					Zip <span className={"required"}>&nbsp;*</span>
				</Label>
				<div
					className={
						errors.zipMissing || errors.zipInvalid
							? fieldErrorWrapperClass
							: undefined
					}
				>
					<Input
						onChange={(e) =>
							handleSetNewPaymentValue("zip", e.target.value as string)
						}
						value={newPaymentValues.zip}
					/>
				</div>
				{errors.zipMissing ? <FieldErrorMessage /> : null}
				{errors.zipInvalid ? (
					<FieldErrorMessage>Enter a valid ZIP code</FieldErrorMessage>
				) : null}
			</div>
		</div>
	);
};
